import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index27.css';const logo = "_logo_mdndn_1";
const letters = "_letters_mdndn_6";
const polygon = "_polygon_mdndn_11";
const s = {
  logo,
  letters,
  polygon
};
const Logo = forwardRef(({ sm, className }, ref) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: `0 0 ${sm ? 90 : 407} 84`,
      className: clsx(s.logo, className),
      children: [
        /* @__PURE__ */ jsxs("g", { className: s.letters, children: [
          /* @__PURE__ */ jsx("path", { d: "M157,65.42h-6.95L145,54H120.06L115,65.42h-6.6l18.88-49.85h9.36C143.35,32.09,150.13,48.66,157,65.42Z M122.52,47.49c3-8.5,6-16.79,9-25.08l.51-.09c3.49,8.32,7,16.64,10.54,25.17Z" }),
          /* @__PURE__ */ jsx("path", { d: "M204.14,24.59c-3.29-1.49-6.2-2.95-9.41-3.38-4.14-.55-8.29-.73-12.21,1.21a13.93,13.93,0,0,0-1.74.95,7,7,0,0,0-3.3,6.35c.15,2.67,2,4.35,4.23,5.42a34.35,34.35,0,0,0,8.63,2.33,49.28,49.28,0,0,1,8.15,2c3.73,1.36,6.82,3.52,8.27,7.37a13.09,13.09,0,0,1-5.16,15.29c-5.47,3.65-11.54,4.31-17.85,3.69A33.73,33.73,0,0,1,173.26,63c-.59-.27-1.14-.61-1.76-.94.39-2.2.12-4.38.92-6.57.86,0,1.41.68,2.08,1.06a25.65,25.65,0,0,0,18.25,3,13.23,13.23,0,0,0,4.37-1.77,6.88,6.88,0,0,0,3.62-6.39c-.11-2.66-1.93-4.16-4-5.28A27.43,27.43,0,0,0,189.82,44c-3-.68-6-1-9-2-.78-.27-1.58-.48-2.33-.82-4.28-1.94-7.25-5-7.74-9.85a13,13,0,0,1,6-12.84,21.18,21.18,0,0,1,11.47-3.59,34.31,34.31,0,0,1,15.06,2.54c.3.13.58.3.84.44Z" }),
          /* @__PURE__ */ jsx("path", { d: "M222.7,62.35c.23-2.41-.35-4.66.54-6.8,1,0,1.61.73,2.31,1.11a25.8,25.8,0,0,0,18.06,2.84,13.62,13.62,0,0,0,4.57-1.91c4.56-2.94,4.53-8.32-.06-11.19a18.76,18.76,0,0,0-5.36-1.92c-3.6-.95-7.35-1.22-10.88-2.46-1-.35-2-.7-3-1.1-10.29-4.24-8.57-17.47-2-21.88A22.55,22.55,0,0,1,239.14,15a33.6,33.6,0,0,1,14.61,2.36c.3.13.61.25.91.4a3.49,3.49,0,0,1,.49.46c-.12,2-.25,4-.38,6.27-1.86-.76-3.56-1.52-5.3-2.16a23.7,23.7,0,0,0-13.72-.79,12.36,12.36,0,0,0-4.28,2c-4.67,3.3-4.19,9.17,1,11.62a34.77,34.77,0,0,0,8.87,2.4,36.55,36.55,0,0,1,10.4,3.07,11.08,11.08,0,0,1,6.21,7.34,13.62,13.62,0,0,1-5,13.93A23.17,23.17,0,0,1,240.19,66,37.08,37.08,0,0,1,222.7,62.35Z" }),
          /* @__PURE__ */ jsx("path", { d: "M319.55,65.44h-6.84c-2-3.65-3.32-7.65-5.23-11.51H282.61q-2.52,5.64-5.11,11.48h-6.61c6.34-16.74,12.63-33.33,18.9-49.9h9.31Z M294.58,22.39c3.45,8.24,6.9,16.48,10.5,25.11-6.79.24-13.27,0-20.09.14l9-25.25Z" }),
          /* @__PURE__ */ jsx("path", { d: "M334.27,18.05a36,36,0,0,1,5.94-2.22c.58,16.56.31,33,.38,49.5a8.85,8.85,0,0,1-3.28.26c-1,0-2,0-3,0Z" }),
          /* @__PURE__ */ jsx("path", { d: "M361.79,65.43h-6.63c6.32-16.68,12.57-33.18,18.89-49.84h9.31l20.32,49.84h-6.92q-2.52-5.72-5.07-11.53H366.88Z M378.53,21.78c3.83,8.58,7.1,17,10.67,25.65H369.37Z" })
        ] }),
        /* @__PURE__ */ jsx(
          "polygon",
          {
            className: s.polygon,
            points: "43.26 1.51 0 80.95 15.51 80.95 43.26 31.71 65.84 69.26 43.8 69.26 37.27 80.95 87.88 80.95 43.26 1.51"
          }
        )
      ]
    }
  );
});
export {
  Logo
};
